const { marked } = require("marked");
const { processText } = require("../helpers");

module.exports = function embedContainer({ content, type, caption }) {
  const captionText = caption ? processText('', caption) : '';

  if (type === 'audio') {
    return `
      <div
        class="
          layout/width:100%
          layout/flex:column
          layout/flex:start
          layout/margin:top:page:2
        "
      >
        ${content}
      </div>
      ${renderCaption(captionText)}
    `;
  }

  // Default to video layout
  return `
    <div
      class="
        layout/width:100%
        layout/flex:column
        layout/flex:start
      "
    >
      <div class="ratio-container">
        <div class="ratio-container__16-9"></div>
        <div class="ratio-container__inner">
          ${content}
        </div>
      </div>
      ${renderCaption(captionText)}
    </div>
  `;
};

function renderCaption(captionText) {
  if (!captionText) return '';
  
  return `<div
    class="
      $@1024/layout/width:85%
      $color/alpha:54%
      $typography/baseline:body
      $typography/size:small
      $typography/weight:regular
      layout/margin:top:cap
    "
    >
    <p
      class="
        typography
      "
      >
      <span class="layout/block balance-text">${captionText}</span>
    </p>
  </div>`;
}
